import React, { useState } from 'react';
import { Tabs as BsTab, Tab } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from './Tabs.module.scss';

export interface Guia {
  key: string;
  titulo: string;
  conteudo: React.ReactNode;
  desabilitado?: boolean;
}

interface TabsProps {
  guias: Guia[];
  confirmRequired?: boolean;
  confirmText?: string;
  defaultKey?: string;
  onTabChange?: (newKey: string) => void;
}

const Tabs: React.FC<TabsProps> = ({ guias, defaultKey, confirmRequired = false, confirmText, onTabChange }) => {
  const [chaveAtiva, setChaveAtiva] = useState<string>(defaultKey || guias[0]?.key);

  const handleTabSelect = (novaChave: string | null) => {
    if (!novaChave || novaChave === chaveAtiva) return;

    if (confirmRequired) {
      const confirmado = window.confirm(confirmText || 'Você tem certeza que deseja mudar de guia?');
      if (!confirmado) return;
    }

    setChaveAtiva(novaChave);
    if (onTabChange) {
      onTabChange(novaChave);
    }
  };

  return (
    <BsTab
      activeKey={chaveAtiva}
      onSelect={handleTabSelect}
      className={styles.tabs}
      justify
    >
      {guias.map((guia) => (
        <Tab
          key={guia.key}
          eventKey={guia.key}
          title={guia.titulo}
          disabled={guia.desabilitado}
        >
          <div className={styles.conteudo}>{guia.conteudo}</div>
        </Tab>
      ))}
    </BsTab>
  );
};

export default Tabs;
